import React from "react";

export const LIFECYCLE_META = {
  open: { label: "Open", color: "#0369a1", bg: "#e0f2fe" },
  assigned: { label: "Assigned", color: "#6d28d9", bg: "#ede9fe" },
  in_progress: { label: "In Progress", color: "#b45309", bg: "#fef3c7" },
  merged: { label: "Merged", color: "#0f766e", bg: "#ccfbf1" },
  verified: { label: "Verified", color: "#15803d", bg: "#dcfce7" },
  realized: { label: "Realized", color: "#166534", bg: "#bbf7d0" },
  dismissed: { label: "Dismissed", color: "#52525b", bg: "#e4e4e7" },
  snoozed: { label: "Snoozed", color: "#92400e", bg: "#ffedd5" },
};

export const LIFECYCLE_ORDER = [
  "open", "assigned", "in_progress", "merged",
  "verified", "realized", "dismissed", "snoozed",
];

export default function LifecyclePill({ status }) {
  const m = LIFECYCLE_META[status] || LIFECYCLE_META.open;
  return (
    <span
      data-testid={`lifecycle-pill-${status || "open"}`}
      className="px-1.5 py-0.5 rounded-sm text-[10px] font-semibold uppercase tracking-[0.08em] whitespace-nowrap"
      style={{ color: m.color, backgroundColor: m.bg }}
    >
      {m.label}
    </span>
  );
}
